import { websocket } from '@/src/shared/lib/websocket'

export function websocketSendAccept(socketId: string): void {
  websocket.emitDefault('accept', { socketId })
}
